var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.currentLayout,{tag:"component"},[_vm._v(_vm._s(_vm.currentLayout))]),(_vm.snackbarNotifications)?_c('snack-bars'):_vm._e(),(!_vm.isImpersonatingUser && !_vm.isSuperAdmin && _vm.user.id)?_c('terms-and-conditions-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }